import { useQuery, useQueryClient } from '@tanstack/react-query';
import { activitiesApi } from '../api';
import type { EngagementSummary } from '../api/types';

// Query keys
export const queryKeys = {
  engagementSummary: (objectId: string, objectType: string) =>
    ['activities', 'engagement', objectType, objectId] as const,
} as const;

// Hook to fetch engagement summary for an object
export function useEngagementSummary(
  objectId: string,
  objectType: string,
  options?: { enabled?: boolean }
) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKeys.engagementSummary(objectId, objectType),
    queryFn: async (): Promise<EngagementSummary> => {
      return await activitiesApi.getEngagementSummary(objectId, objectType);
    },
    enabled: options?.enabled !== false && !!objectId && !!objectType,
    staleTime: 1000 * 10, // 2 minutes
  });

  // Provide a refetch function for manual updates
  const refetch = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.engagementSummary(objectId, objectType),
    });
  };

  return {
    ...query,
    refetch,
  };
}
